import urljoin from 'url-join';

export const authRedirect = (url, continueUrl) => {
  return urljoin(url, `?continue=${encodeURIComponent(continueUrl)}`);
}
